import Option from './Option'
const Options = ({items, className='', onKeyPress, onClick}) => {
  return <section className={`optionslist ${className}`}>
    {items.map((item, key) => <Option onClick={onClick} onKeyPress={onKeyPress} key={key} {...item} />)}
  </section>
}

export default Options